import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api, type TopBuyerMetric, type UserPageFilter } from "@/api";

export const userKeys = {
	all: ["users"] as const,
	page: (filter: UserPageFilter) => ["users", "page", filter] as const,
	detail: (id: string) => ["users", "detail", id] as const,
	staff: (id: string) => ["users", "staff", id] as const,
	topBuyers: (metric: TopBuyerMetric, days?: number) =>
		["users", "top-buyers", metric, days ?? "all"] as const,
};

export function useUsers() {
	return useQuery({
		queryKey: userKeys.all,
		queryFn: () => api.users.list(),
	});
}

/** Страница пользователей с сервера; прежняя видна, пока грузится следующая. */
export function useUserPage(filter: UserPageFilter) {
	return useQuery({
		queryKey: userKeys.page(filter),
		queryFn: () => api.users.page(filter),
		placeholderData: keepPreviousData,
	});
}

export function useUser(id: string) {
	return useQuery({
		queryKey: userKeys.detail(id),
		queryFn: () => api.users.get(id),
		enabled: !!id,
	});
}

export function useUserStaff(id: string) {
	return useQuery({
		queryKey: userKeys.staff(id),
		queryFn: () => api.users.staff(id),
		enabled: !!id,
	});
}

export function useBuyerAnalytics(id: string, enabled: boolean) {
	return useQuery({
		queryKey: ["users", "buyer-analytics", id],
		queryFn: () => api.users.buyerAnalytics(id),
		enabled: !!id && enabled,
		refetchOnWindowFocus: false,
	});
}

export function useTopBuyers(metric: TopBuyerMetric, days?: number, limit = 20) {
	return useQuery({
		queryKey: userKeys.topBuyers(metric, days),
		queryFn: () => api.users.topBuyers({ metric, days, limit }),
		refetchOnWindowFocus: false,
	});
}

